"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedNoStaffOnline =
/*#__PURE__*/
function (_pb_1$NoStaffOnline) {
  _inherits(ExtendedNoStaffOnline, _pb_1$NoStaffOnline);

  function ExtendedNoStaffOnline(properties) {
    var _this;

    _classCallCheck(this, ExtendedNoStaffOnline);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedNoStaffOnline).call(this, properties));
    _this.type = ExtendedNoStaffOnline.type;
    _this.chreqid = properties.proxy.chreqid;
    return _this;
  }

  _createClass(ExtendedNoStaffOnline, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.proxy.guest).concat(ExtendedNoStaffOnline.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.NoStaffOnline.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedNoStaffOnline(pb_1.NoStaffOnline.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedNoStaffOnline;
}(pb_1.NoStaffOnline);

ExtendedNoStaffOnline.type = "NoStaffOnline";
ExtendedNoStaffOnline.context = "/guest-chat/cancel/no-staff";
exports.NoStaffOnline = ExtendedNoStaffOnline;